exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logout_title[data-v-8ef766a4] {\n  color: inherit;\n  text-decoration: none;\n}\n", ""]);

// exports
